import { Calendar } from "@heroui/react";
import { CalendarDate } from "@internationalized/date";
import { I18nProvider } from "@react-aria/i18n";
import { useEffect, useState } from "react";
import Modal from "./modal";
import { Icon } from "@iconify/react";
import { Button } from "@heroui/react";
import { isMobile } from "@/stores/MenuStore";
interface CalendaryProps {
    selectedDate: string | null;
    onDateChange: (newDate: string | null) => void;
    minMonth?: number;
    maxMonth?: number;
    isCard?: boolean;
}

export default function Calendary({ selectedDate, onDateChange, minMonth = -12, maxMonth = 1, isCard = false }: CalendaryProps) {

    const [isOpen, setIsOpen] = useState(false);

    const parseDate = (dateStr: string | null): CalendarDate | null => {
        if (dateStr) {
            const [year, month, day] = dateStr.split('-').map(Number);
            return new CalendarDate(year, month, day);
        }
        const today = new Date();
        return new CalendarDate(today.getFullYear(), today.getMonth() + 1, today.getDate());
    };

    const [date, setDate] = useState<CalendarDate | null>(parseDate(selectedDate))

    const formatDate = (date: CalendarDate | null): string => {
        return date ? `${date.year}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}` : "No date";
    };

    const extractDayFromDate = (dateString: string): string => {
        const day = dateString.split("-")[2];
        return day.padStart(2, "0");
    }

    useEffect(() => {
        onDateChange(formatDate(date));
        setIsOpen(false);
    }, [date]);

    const getMinMaxDates = (n: number): CalendarDate => {
        const today = new Date();
        today.setMonth(today.getMonth() + n);
        return new CalendarDate(today.getFullYear(), today.getMonth() + 1, today.getDate());
    };

    const renderCalendar = () => {
        return (
            <I18nProvider locale="pt-BR-u-ca-gregory">
                <Calendar
                    calendarWidth={'300px'}
                    className=" overflow-hidden border-1 border-default-50"
                    color="primary"
                    value={date}
                    onChange={setDate}
                    minValue={getMinMaxDates(minMonth)}
                    maxValue={getMinMaxDates(maxMonth)}
                />
            </I18nProvider>
        );
    }

    return (
        <div className="mx-auto">
            {isMobile() && isCard ?
                <>
                    <Button className="flex p-0 w-[50px] h-[44px] bg-content2" onClick={() => setIsOpen(true)}>
                        <div className="px-3 flex gap-2 items-center justify-center text-default-700">
                            <Icon className="text-2xl" icon="solar:calendar-outline" />
                            {date && <span className=" pt-1 font-mono text-lg font-medium">{extractDayFromDate(formatDate(date))}</span>}
                        </div>
                    </Button>
                    <Modal
                        placement="top-center"
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        classBody="flex items-center p-2"
                        body={renderCalendar()}
                    />
                </>
                :
                <>
                    {renderCalendar()}
                </>
            }

        </div>
    );
}
